import ApiRequest from '../../utils/APIRequestPredict';

export default class Predict {

  static predict = async (values) => {
    return await ApiRequest.set('predict', 'PUT', values)
  } 

  static hello = async () => {
    return await ApiRequest.set('helloo', 'GET')
  }

}
